module.exports = __webpack_public_path__ + "img/back_28.3db796be.svg";